var items = {
  "block.minecraft.air": "ಗಾಳಿ",
  "block.minecraft.stone": "ಕಲ್ಲು",
  "block.minecraft.granite": "ಗ್ರಾನೈಟ್",
  "block.minecraft.polished_granite": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್",
  "block.minecraft.diorite": "ಡಿಯೊರೈಟ್",
  "block.minecraft.polished_diorite": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್",
  "block.minecraft.andesite": "ಅಂಡಿಸೈಟ್",
  "block.minecraft.polished_andesite": "ನಯಗೊಳಿಸಿದ ಅಂಡಿಸೈಟ್",
  "block.minecraft.grass_block": "ಹುಲ್ಲು ಘನಗ",
  "block.minecraft.dirt": "ಮಣ್ಣು",
  "block.minecraft.coarse_dirt": "ಒರಟಾದ ಕೊಳಕು",
  "block.minecraft.podzol": "ಪೊಡ್ಜೋಲ್",
  "block.minecraft.crimson_nylium": "ಕ್ರಿಮ್ಸನ್ ನೈಲಿಯಮ್",
  "block.minecraft.warped_nylium": "ರ್ಯಾಪ್ಡ್ ನೈಲಿಯಮ್",
  "block.minecraft.cobblestone": "ನುಣುಪುಗಲ್ಲು",
  "block.minecraft.oak_planks": "ಓಕ್ ಹಲಗೆಗಳು",
  "block.minecraft.spruce_planks": "ಸ್ಪ್ರೂಸ್ ಪ್ಲ್ಯಾಂಕ್ಸ್",
  "block.minecraft.birch_planks": "ಬರ್ಚ್ ಹಲಗೆಗಳು",
  "block.minecraft.jungle_planks": "ಜಂಗಲ್ ಹಲಗೆಗಳು",
  "block.minecraft.acacia_planks": "ಅಕೇಶಿಯ ಪ್ಲಾಂಕ್ಸ್",
  "block.minecraft.dark_oak_planks": "ಡಾರ್ಕ್ ಓಕ್ ಹಲಗೆಗಳು",
  "block.minecraft.crimson_planks": "ಕ್ರಿಮ್ಸನ್ ಹಲಗೆಗಳು",
  "block.minecraft.warped_planks": "ರ್ಯಾಪ್ಡ್ ಹಲಗೆಗಳು",
  "block.minecraft.oak_sapling": "ಓಕ್ ಸಸಿಲಿಂಗ್",
  "block.minecraft.spruce_sapling": "ಸ್ಪ್ರೂಸ್ ಸಸಿಂಗ್",
  "block.minecraft.birch_sapling": "ಬರ್ಚ್ ಸಸಿ",
  "block.minecraft.jungle_sapling": "ಜಂಗಲ್ ಸಪ್ಲಿಂಗ್",
  "block.minecraft.acacia_sapling": "ಅಕೇಶಿಯ ಸಸಿ",
  "block.minecraft.dark_oak_sapling": "ಡಾರ್ಕ್ ಓಕ್ ಸಸಿಂಗ್",
  "block.minecraft.bedrock": "ಕಲ್ಲುಹಾಸನ್ನು",
  "block.minecraft.sand": "ಕೆಂಪು",
  "block.minecraft.red_sand": "ಕೆಂಪು ಮರಳು",
  "block.minecraft.gravel": "ಜಲ್ಲಿ",
  "block.minecraft.gold_ore": "ಚಿನ್ನದ ಅದಿರು",
  "block.minecraft.iron_ore": "ಕಬ್ಬಿಣದ ಅದಿರು",
  "block.minecraft.coal_ore": "ಕಲ್ಲಿದ್ದಲು ಅದಿರು",
  "block.minecraft.nether_gold_ore": "ಹೆಲ್ ನ ಚಿನ್ನದ ಅದಿರು",
  "block.minecraft.oak_log": "ಓಕ್ ಲಾಗ್",
  "block.minecraft.spruce_log": "ಲಾಗ್ ಸ್ಪ್ರೂಸ್",
  "block.minecraft.birch_log": "ಬಿರ್ಚ್ ಲಾಗ್",
  "block.minecraft.jungle_log": "ಜಂಗಲ್ ಲಾಗ್",
  "block.minecraft.acacia_log": "ಅಕೇಶಿಯ ಲಾಗ್",
  "block.minecraft.dark_oak_log": "ಡಾರ್ಕ್ ಓಕ್ ಲಾಗ್",
  "block.minecraft.crimson_stem": "ಕ್ರಿಮ್ಸನ್ ಸ್ಟೆಮ್",
  "block.minecraft.warped_stem": "ರ್ಯಾಪ್ಡ್ ಸ್ಟೆಮ್",
  "block.minecraft.stripped_oak_log": "ಓಕ್ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_spruce_log": "ಸ್ಟ್ರಿಪ್ಡ್ ಸ್ಪ್ರೂಸ್ ಲಾಗ್",
  "block.minecraft.stripped_birch_log": "ಬಿರ್ಚ್ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_jungle_log": "ಸ್ಟ್ರಿಪ್ಡ್ ಜಂಗಲ್ ಲಾಗ್",
  "block.minecraft.stripped_acacia_log": "ಅಕೇಶಿಯ ಲಾಗ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_dark_oak_log": "ಸ್ಟ್ರೈಪ್ಡ್ ಡಾರ್ಕ್ ಓಕ್ ಲಾಗ್",
  "block.minecraft.stripped_crimson_stem": "ಸ್ಟ್ರಿಪ್ಡ್ ಕ್ರಿಮ್ಸನ್ ಸ್ಟೆಮ್",
  "block.minecraft.stripped_warped_stem": "ಸ್ಟ್ರಿಪ್ಡ್ ವಾರ್ಪ್ಡ್ ಕಾಂಡ",
  "block.minecraft.stripped_oak_wood": "ಓಕ್ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_spruce_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಸ್ಪ್ರೂಸ್ ವುಡ್",
  "block.minecraft.stripped_birch_wood": "ಬಿರ್ಚ್ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_jungle_wood": "ಸ್ಟ್ರಿಪ್ಡ್ ಜಂಗಲ್ ವುಡ್",
  "block.minecraft.stripped_acacia_wood": "ಅಕೇಶಿಯ ವುಡ್ ಸ್ಟ್ರಿಪ್ಡ್",
  "block.minecraft.stripped_dark_oak_wood": "ಸ್ಟ್ರೈಪ್ಡ್ ಡಾರ್ಕ್ ಓಕ್ ವುಡ್",
  "block.minecraft.stripped_crimson_hyphae": "ಸ್ಟ್ರಿಪ್ಡ್ ಕ್ರಿಮ್ಸನ್ ಹೈಫೇ",
  "block.minecraft.stripped_warped_hyphae": "ಸ್ಟ್ರಿಪ್ಡ್ ವಾರ್ಪ್ಡ್ ಹೈಫೇ",
  "block.minecraft.oak_wood": "ಓಕ್ ಕಟ್ಟಿಗೆ",
  "block.minecraft.spruce_wood": "ಸ್ಪ್ರೂಸ್ ವುಡ್",
  "block.minecraft.birch_wood": "ಬರ್ಚ್ ಕಟ್ಟಿಗೆ",
  "block.minecraft.jungle_wood": "ಜಂಗಲ್ ವುಡ್",
  "block.minecraft.acacia_wood": "ಅಕೇಶಿಯ ವುಡ್",
  "block.minecraft.dark_oak_wood": "ಡಾರ್ಕ್ ಓಕ್ ವುಡ್",
  "block.minecraft.crimson_hyphae": "ಕ್ರಿಮ್ಸನ್ ಹೈಫೇ",
  "block.minecraft.warped_hyphae": "ರ್ಯಾಪ್ಡ್ ಹೈಫೇ",
  "block.minecraft.oak_leaves": "ಓಕ್ ಎಲೆಗಳು",
  "block.minecraft.spruce_leaves": "ಸ್ಪ್ರೂಸ್ ಎಲೆಗಳು",
  "block.minecraft.birch_leaves": "ಬಿರ್ಚ್ ಎಲೆಗಳು",
  "block.minecraft.jungle_leaves": "ಜಂಗಲ್ ಎಲೆಗಳು",
  "block.minecraft.acacia_leaves": "ಅಕೇಶಿಯ ಎಲೆಗಳು",
  "block.minecraft.dark_oak_leaves": "ಡಾರ್ಕ್ ಓಕ್ ಎಲೆಗಳು",
  "block.minecraft.sponge": "ಸ್ಪಾಂಜ್",
  "block.minecraft.wet_sponge": "ವೆಟ್ ಸ್ಪಾಂಜ್",
  "block.minecraft.glass": "ಗಾಜು",
  "block.minecraft.lapis_ore": "ಲ್ಯಾಪಿಸ್ ಲಾಝುಲಿ ಅದಿರು",
  "block.minecraft.lapis_block": "ಲ್ಯಾಪಿಸ್ ಲಾಝುಲಿ ಅದಿರು",
  "block.minecraft.dispenser": "ವಿತರಕ",
  "block.minecraft.sandstone": "ಮರಳುಗಲ್ಲು",
  "block.minecraft.chiseled_sandstone": "ಕತ್ತರಿಸಿದ ಮರಳುಗಲ್ಲು",
  "block.minecraft.cut_sandstone": "ಮರಳುಗಲ್ಲು ಕತ್ತರಿಸಿ",
  "block.minecraft.note_block": "ಟಿಪ್ಪಣಿ ಬ್ಲಾಕ್",
  "block.minecraft.powered_rail": "ಚಾಲಿತ ರೈಲು",
  "block.minecraft.detector_rail": "ಡಿಟೆಕ್ಟರ್ ರೈಲು",
  "block.minecraft.sticky_piston": "ಸ್ಟಿಕಿ ಪಿಸ್ಟನ್",
  "block.minecraft.cobweb": "ಜೇಡನ ಬಲೆ",
  "block.minecraft.grass": "ಹುಲ್ಲು",
  "block.minecraft.fern": "ಜರೀಗಿಡ",
  "block.minecraft.dead_bush": "ಡೆಡ್ ಬುಷ್",
  "block.minecraft.seagrass": "ಸೀಗ್ರಾಸ್",
  "block.minecraft.sea_pickle": "ಸಮುದ್ರ ಉಪ್ಪಿನಕಾಯಿ",
  "block.minecraft.piston": "ಪಿಸ್ಟನ್",
  "block.minecraft.white_wool": "ಬಿಳಿ ಉಣ್ಣೆ",
  "block.minecraft.orange_wool": "ಕಿತ್ತಳೆ ಉಣ್ಣೆ",
  "block.minecraft.magenta_wool": "ಕೆನ್ನೇರಳೆ ಉಣ್ಣೆ",
  "block.minecraft.light_blue_wool": "ಲೈಟ್ ಬ್ಲೂ ಗ್ಲೋಬ್",
  "block.minecraft.yellow_wool": "ಹಳದಿ ಉಣ್ಣೆ",
  "block.minecraft.lime_wool": "ಬಿಳಿ ಉಣ್ಣೆ",
  "block.minecraft.pink_wool": "ಗುಲಾಬಿ ಉಣ್ಣೆ",
  "block.minecraft.gray_wool": "ಹಸಿರು ಉಣ್ಣೆ",
  "block.minecraft.light_gray_wool": "ಲೈಟ್ ಗ್ರೇ ಗ್ಲೋಬ್",
  "block.minecraft.cyan_wool": "ವೈಡೂರ್ಯ ಉಣ್ಣೆ",
  "block.minecraft.purple_wool": "ನೇರಳೆ ಉಣ್ಣೆ",
  "block.minecraft.blue_wool": "ನೀಲಿ ಉಣ್ಣೆ",
  "block.minecraft.brown_wool": "ಕಂದು ಉಣ್ಣೆ",
  "block.minecraft.green_wool": "ಹಸಿರು ಉಣ್ಣೆ",
  "block.minecraft.red_wool": "ಕೆಂಪು ಉಣ್ಣೆ",
  "block.minecraft.black_wool": "ಕಪ್ಪು ಉಣ್ಣೆ",
  "block.minecraft.dandelion": "ಡ್ಯಾಂಡಲಿಯನ್",
  "block.minecraft.poppy": "ಗಸಗಸೆ",
  "block.minecraft.blue_orchid": "ನೀಲಿ ಆರ್ಕಿಡ್",
  "block.minecraft.allium": "ಆಲಿಯಮ್",
  "block.minecraft.azure_bluet": "ಅಜುರೆ ಬ್ಲೂಟ್",
  "block.minecraft.red_tulip": "ಕೆಂಪು ಟುಲಿಪ್",
  "block.minecraft.orange_tulip": "ಕಿತ್ತಳೆ ತುಲಿಪ್",
  "block.minecraft.white_tulip": "ಬಿಳಿ ಟುಲಿಪ್",
  "block.minecraft.pink_tulip": "ಗುಲಾಬಿ ತುಲಿಪ್",
  "block.minecraft.oxeye_daisy": "ಆಕ್ಸೀ ಡೈಸಿ",
  "block.minecraft.cornflower": "ಕಾರ್ನ್ಫ್ಲವರ್",
  "block.minecraft.lily_of_the_valley": "ಲಿಲಿ ಆಫ್ ದಿ ವ್ಯಾಲಿ",
  "block.minecraft.wither_rose": "ವಿದರ್ಸ್ ರೋಸ್",
  "block.minecraft.brown_mushroom": "ಬ್ರೌನ್ ಮಶ್ರೂಮ್",
  "block.minecraft.red_mushroom": "ಕೆಂಪು ಮಶ್ರೂಮ್",
  "block.minecraft.crimson_fungus": "ಕ್ರಿಮ್ಸನ್ ಶಿಲೀಂಧ್ರ",
  "block.minecraft.warped_fungus": "ರ್ಯಾಪ್ಡ್ ಶಿಲೀಂಧ್ರ",
  "block.minecraft.crimson_roots": "ಕ್ರಿಮ್ಸನ್ ರೂಟ್ಸ್",
  "block.minecraft.warped_roots": "ರ್ಯಾಪ್ಡ್ ರೂಟ್ಸ್",
  "block.minecraft.nether_sprouts": "ನೆದರ್ ಮೊಗ್ಗುಗಳು",
  "block.minecraft.weeping_vines": "ಅಳುವ ಬಳ್ಳಿಗಳು",
  "block.minecraft.twisting_vines": "ಒಂದು ವೇಳೆ",
  "block.minecraft.sugar_cane": "ಕಬ್ಬು",
  "block.minecraft.kelp": "ಕೆಲ್ಪ್",
  "block.minecraft.bamboo": "ಬಿದಿರು",
  "block.minecraft.gold_block": "ಗೋಲ್ಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.iron_block": "ಐರನ್ ಬ್ಲಾಕ್",
  "block.minecraft.oak_slab": "ಓಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.spruce_slab": "ಸ್ಪ್ರೂಸ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.birch_slab": "ಬಿರ್ಚ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.jungle_slab": "ಜಂಗಲ್ ಚಪ್ಪಡಿ",
  "block.minecraft.acacia_slab": "ಅಕೇಶಿಯ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.dark_oak_slab": "ಡಾರ್ಕ್ ಓಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.crimson_slab": "ಕ್ರಿಮ್ಸನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.warped_slab": "ರ್ಯಾಪ್ಡ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.stone_slab": "ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.smooth_stone_slab": "ಸ್ಮೂತ್ ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.sandstone_slab": "ಮರಳುಗಲ್ಲು ಚಪ್ಪಡಿ",
  "block.minecraft.cut_sandstone_slab": "ಕಲ್ಲಿನ ಮರಳುಗಲ್ಲಿನ ಚಪ್ಪಡಿ",
  "block.minecraft.petrified_oak_slab": "ಪೆಟ್ರಿಫೈಡ್ ಓಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.cobblestone_slab": "ಕೋಬ್ಲೆಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.brick_slab": "ಇಟ್ಟಿಗೆ ಚಪ್ಪಡಿ",
  "block.minecraft.stone_brick_slab": "ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.nether_brick_slab": "ನೆದರ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.quartz_slab": "ಸ್ಫಟಿಕ ಚಪ್ಪಡಿ",
  "block.minecraft.red_sandstone_slab": "ಕೆಂಪು ಮರಳುಗಲ್ಲಿನ ಚಪ್ಪಡಿ",
  "block.minecraft.cut_red_sandstone_slab": "ಕಟ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.purpur_slab": "ಪುರ್ಪುರ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.prismarine_slab": "ಪ್ರಿಸ್ಮರಿನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.prismarine_brick_slab": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.dark_prismarine_slab": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_quartz": "ಸುಗಮ ಸ್ಫಟಿಕ ಬ್ಲಾಕ್",
  "block.minecraft.smooth_red_sandstone": "ನಯವಾದ ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.smooth_sandstone": "ನಯವಾದ ಮರಳುಗಲ್ಲು",
  "block.minecraft.smooth_stone": "ನಯವಾದ ಕಲ್ಲು",
  "block.minecraft.bricks": "ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "ಪುಸ್ತಕದ ಕಪಾಟು",
  "block.minecraft.mossy_cobblestone": "ಮೊಸ್ಸಿ ಕೋಬ್ಲೆಸ್ಟೋನ್",
  "block.minecraft.obsidian": "ಒಬ್ಸಿಡಿಯನ್",
  "block.minecraft.torch": "ಟಾರ್ಚ್",
  "block.minecraft.end_rod": "ಎಂಡ್ ರಾಡ್",
  "block.minecraft.chorus_plant": "ಕೋರಸ್ ಸಸ್ಯ",
  "block.minecraft.chorus_flower": "ಕೋರಸ್ ಹೂ",
  "block.minecraft.purpur_block": "ಪುರ್ಪುರ್ ಬ್ಲಾಕ್",
  "block.minecraft.purpur_pillar": "ಪುರ್ಪುರ್ ಕಂಬ",
  "block.minecraft.purpur_stairs": "ಪುರ್ಪುರ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.spawner": "ಸ್ಪಾನರ್",
  "block.minecraft.oak_stairs": "ಓಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.chest": "ಎದೆ",
  "block.minecraft.diamond_ore": "ಡೈಮಂಡ್ ಅದಿರು",
  "block.minecraft.diamond_block": "ಡೈಮಂಡ್ನ ಬ್ಲಾಕ್",
  "block.minecraft.crafting_table": "ಕ್ರಾಫ್ಟಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.farmland": "ಕೃಷಿಭೂಮಿ",
  "block.minecraft.furnace": "ಕುಲುಮೆ",
  "block.minecraft.ladder": "ಏಣಿ",
  "block.minecraft.rail": "ರೈಲು",
  "block.minecraft.cobblestone_stairs": "ಕೋಬ್ಲೆಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.lever": "ಲಿವರ್",
  "block.minecraft.stone_pressure_plate": "ಕಲ್ಲು ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.oak_pressure_plate": "ಓಕ್ ಒತ್ತಡದ ಪ್ಲೇಟ್",
  "block.minecraft.spruce_pressure_plate": "ಸ್ಪ್ರೂಸ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.birch_pressure_plate": "ಬಿರ್ಚ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.jungle_pressure_plate": "ಜಂಗಲ್ ಒತ್ತಡ ಪ್ಲೇಟ್",
  "block.minecraft.acacia_pressure_plate": "ಅಕೇಶಿಯ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.dark_oak_pressure_plate": "ಡಾರ್ಕ್ ಓಕ್ ಒತ್ತಡದ ಪ್ಲೇಟ್",
  "block.minecraft.crimson_pressure_plate": "ಕ್ರಿಮ್ಸನ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.warped_pressure_plate": "ರ್ಯಾಪ್ಡ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.polished_blackstone_pressure_plate": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಪ್ರೆಶರ್ ಪ್ಲೇಟ್",
  "block.minecraft.redstone_ore": "ರೆಡ್‌ಸ್ಟೋನ್ ಅದಿರು",
  "block.minecraft.redstone_torch": "ರೆಡ್ಸ್ಟೋನ್ ಟಾರ್ಚ್",
  "block.minecraft.snow": "ಹಿಮ",
  "block.minecraft.ice": "ಐಸ್",
  "block.minecraft.snow_block": "ಹಿಮ ಘನಗ",
  "block.minecraft.cactus": "ಕಳ್ಳಿ",
  "block.minecraft.clay": "ಮಣ್ಣಿನ",
  "block.minecraft.jukebox": "ಜೂಕ್ಬಾಕ್ಸ್",
  "block.minecraft.oak_fence": "ಓಕ್ ಬೇಲಿ",
  "block.minecraft.spruce_fence": "ಸ್ಪ್ರೂಸ್ ಬೇಲಿ",
  "block.minecraft.birch_fence": "ಬಿರ್ಚ್ ಬೇಲಿ",
  "block.minecraft.jungle_fence": "ಜಂಗಲ್ ಫೆನ್ಸ್",
  "block.minecraft.acacia_fence": "ಅಕೇಶಿಯ ಬೇಲಿ",
  "block.minecraft.dark_oak_fence": "ಡಾರ್ಕ್ ಓಕ್ ಫೆನ್ಸ್",
  "block.minecraft.crimson_fence": "ಕ್ರಿಮ್ಸನ್ ಬೇಲಿ",
  "block.minecraft.warped_fence": "ರ್ಯಾಪ್ಡ್ ಬೇಲಿ",
  "block.minecraft.pumpkin": "ಕುಂಬಳಕಾಯಿ",
  "block.minecraft.carved_pumpkin": "ಕೆತ್ತಿದ ಕುಂಬಳಕಾಯಿ",
  "block.minecraft.netherrack": "ನೆದರ್ರಾಕ್",
  "block.minecraft.soul_sand": "ಸೋಲ್ ಸ್ಯಾಂಡ್",
  "block.minecraft.soul_soil": "ಆತ್ಮ ಮಣ್ಣು",
  "block.minecraft.basalt": "ಬಸಾಲ್ಟ್",
  "block.minecraft.polished_basalt": "ನಯಗೊಳಿಸಿದ ಬಸಾಲ್ಟ್",
  "block.minecraft.soul_torch": "ಸೋಲ್ ಟಾರ್ಚ್",
  "block.minecraft.glowstone": "ಗ್ಲೋಸ್ಟೋನ್",
  "block.minecraft.jack_o_lantern": "ಜ್ಯಾಕ್ ಒ ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.oak_trapdoor": "ಓಕ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.spruce_trapdoor": "ಸ್ಪ್ರೂಸ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.birch_trapdoor": "ಬಿರ್ಚ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.jungle_trapdoor": "ಜಂಗಲ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.acacia_trapdoor": "ಅಕೇಶಿಯ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.dark_oak_trapdoor": "ಡಾರ್ಕ್ ಓಕ್ ಟ್ರ್ಯಾಪ್ಡೂರ್",
  "block.minecraft.crimson_trapdoor": "ಕ್ರಿಮ್ಸನ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.warped_trapdoor": "ರ್ಯಾಪ್ಡ್ ಟ್ರ್ಯಾಪ್ಡೋರ್",
  "block.minecraft.infested_stone": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲು",
  "block.minecraft.infested_cobblestone": "ಸೋಂಕಿತ ಕೋಬ್ಲೆಸ್ಟೋನ್",
  "block.minecraft.infested_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_mossy_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಪಾಚಿ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_cracked_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕಲ್ಲಿನ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.infested_chiseled_stone_bricks": "ಮುತ್ತಿಕೊಂಡಿರುವ ಕತ್ತರಿಸಿದ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.stone_bricks": "ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.mossy_stone_bricks": "ಪಾಚಿ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.cracked_stone_bricks": "ಬಿರುಕು ಬಿಟ್ಟ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.chiseled_stone_bricks": "ಕತ್ತರಿಸಿದ ಕಲ್ಲು ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.brown_mushroom_block": "ಬ್ರೌನ್ ಮಶ್ರೂಮ್ ಬ್ಲಾಕ್",
  "block.minecraft.red_mushroom_block": "ಕೆಂಪು ಮಶ್ರೂಮ್ ಬ್ಲಾಕ್",
  "block.minecraft.mushroom_stem": "ಮಶ್ರೂಮ್ ಕಾಂಡ",
  "block.minecraft.iron_bars": "ಐರನ್ ಬಾರ್ಸ್",
  "block.minecraft.chain": "ಚೈನ್",
  "block.minecraft.glass_pane": "ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.melon": "ಕಲ್ಲಂಗಡಿ",
  "block.minecraft.vine": "ಬಳ್ಳಿಗಳು",
  "block.minecraft.oak_fence_gate": "ಓಕ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.spruce_fence_gate": "ಸ್ಪ್ರೂಸ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.birch_fence_gate": "ಬಿರ್ಚ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.jungle_fence_gate": "ಜಂಗಲ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.acacia_fence_gate": "ಅಕೇಶಿಯ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.dark_oak_fence_gate": "ಡಾರ್ಕ್ ಓಕ್ ಫೆನ್ಸ್ ಗೇಟ್",
  "block.minecraft.crimson_fence_gate": "ಕ್ರಿಮ್ಸನ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.warped_fence_gate": "ರ್ಯಾಪ್ಡ್ ಬೇಲಿ ಗೇಟ್",
  "block.minecraft.brick_stairs": "ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.stone_brick_stairs": "ಕಲ್ಲು ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mycelium": "ಕವಕಜಾಲ",
  "block.minecraft.lily_pad": "ಲಿಲಿ ಪ್ಯಾಡ್",
  "block.minecraft.nether_bricks": "ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.cracked_nether_bricks": "ಕ್ರ್ಯಾಕ್ಡ್ ನೆದರ್ ಬ್ರಿಕ್ಸ್",
  "block.minecraft.chiseled_nether_bricks": "ಕತ್ತರಿಸಿದ ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.nether_brick_fence": "ನೆದರ್ ಬ್ರಿಕ್ ಬೇಲಿ",
  "block.minecraft.nether_brick_stairs": "ನೆದರ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.enchanting_table": "ಮೋಡಿಮಾಡುವ ಟೇಬಲ್",
  "block.minecraft.end_portal_frame": "ಪೋರ್ಟಲ್ ಫ್ರೇಮ್ ಅನ್ನು ಕೊನೆಗೊಳಿಸಿ",
  "block.minecraft.end_stone": "ಎಂಡ್ ಸ್ಟೋನ್",
  "block.minecraft.end_stone_bricks": "ಸ್ಟೋನ್ ಬ್ರಿಕ್ಸ್ ಅನ್ನು ಕೊನೆಗೊಳಿಸಿ",
  "block.minecraft.dragon_egg": "ಡ್ರ್ಯಾಗನ್ ಮೊಟ್ಟೆ",
  "block.minecraft.redstone_lamp": "ರೆಡ್ಸ್ಟೋನ್ ಲ್ಯಾಂಪ್",
  "block.minecraft.sandstone_stairs": "ಮರಳುಗಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.emerald_ore": "ಪಚ್ಚೆ ಅದಿರು",
  "block.minecraft.ender_chest": "ಎಂಡರ್ ಎದೆ",
  "block.minecraft.tripwire_hook": "ಟ್ರಿಪ್‌ವೈರ್ ಹುಕ್",
  "block.minecraft.emerald_block": "ಪಚ್ಚೆ ಘನಗ",
  "block.minecraft.spruce_stairs": "ಸ್ಪ್ರೂಸ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.birch_stairs": "ಬರ್ಚ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.jungle_stairs": "ಜಂಗಲ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.crimson_stairs": "ಕ್ರಿಮ್ಸನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.warped_stairs": "ರ್ಯಾಪ್ಡ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.command_block": "ಕಮಾಂಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.beacon": "ಬೀಕನ್",
  "block.minecraft.cobblestone_wall": "ಕೋಬ್ಲೆಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.mossy_cobblestone_wall": "ಮೊಸ್ಸಿ ಕೋಬ್ಲೆಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.brick_wall": "ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.prismarine_wall": "ಪ್ರಿಸ್ಮರಿನ್ ಗೋಡೆ",
  "block.minecraft.red_sandstone_wall": "ಕೆಂಪು ಮರಳುಗಲ್ಲು ಗೋಡೆ",
  "block.minecraft.mossy_stone_brick_wall": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ವಾಲ್",
  "block.minecraft.granite_wall": "ಗ್ರಾನೈಟ್ ಗೋಡೆ",
  "block.minecraft.stone_brick_wall": "ಕಲ್ಲಿನ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.nether_brick_wall": "ನೆದರ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.andesite_wall": "ಅಂಡಿಸೈಟ್ ವಾಲ್",
  "block.minecraft.red_nether_brick_wall": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.sandstone_wall": "ಮರಳುಗಲ್ಲಿನ ಗೋಡೆ",
  "block.minecraft.end_stone_brick_wall": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ವಾಲ್",
  "block.minecraft.diorite_wall": "ಡಿಯೊರೈಟ್ ಗೋಡೆ",
  "block.minecraft.blackstone_wall": "ಬ್ಲಾಕ್ಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.polished_blackstone_wall": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ವಾಲ್",
  "block.minecraft.polished_blackstone_brick_wall": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆ ಗೋಡೆ",
  "block.minecraft.stone_button": "ಕಲ್ಲು ಬಟನ್",
  "block.minecraft.oak_button": "ಓಕ್ ಬಟನ್",
  "block.minecraft.spruce_button": "ಸ್ಪ್ರೂಸ್ ಬಟನ್",
  "block.minecraft.birch_button": "ಬರ್ಚ್ ಬಟನ್",
  "block.minecraft.jungle_button": "ಜಂಗಲ್ ಬಟನ್",
  "block.minecraft.acacia_button": "ಅಕೇಶಿಯ ಬಟನ್",
  "block.minecraft.dark_oak_button": "ಡಾರ್ಕ್ ಓಕ್ ಬಟನ್",
  "block.minecraft.crimson_button": "ಕ್ರಿಮ್ಸನ್ ಬಟನ್",
  "block.minecraft.warped_button": "ರ್ಯಾಪ್ಡ್ ಬಟನ್",
  "block.minecraft.polished_blackstone_button": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಬಟನ್",
  "block.minecraft.anvil": "ಬಡಿಗಲ್ಲು",
  "block.minecraft.chipped_anvil": "ಚಿಪ್ಡ್ ಅನ್ವಿಲ್",
  "block.minecraft.damaged_anvil": "ಹಾನಿಗೊಳಗಾದ ಅನ್ವಿಲ್",
  "block.minecraft.trapped_chest": "ಸಿಕ್ಕಿಬಿದ್ದ ಎದೆ",
  "block.minecraft.light_weighted_pressure_plate": "ಕಡಿಮೆ ತೂಕದ ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.heavy_weighted_pressure_plate": "ಹೆವಿ ತೂಕದ ಒತ್ತಡದ ಫಲಕ",
  "block.minecraft.daylight_detector": "ಡೇಲೈಟ್ ಡಿಟೆಕ್ಟರ್",
  "block.minecraft.redstone_block": "ರೆಡ್ಸ್ಟೋನ್ ಘನಗ",
  "block.minecraft.nether_quartz_ore": "ನೆದರ್ ಸ್ಫಟಿಕ ಅದಿರು",
  "block.minecraft.hopper": "ಹಾಪರ್",
  "block.minecraft.chiseled_quartz_block": "ಕತ್ತರಿಸಿದ ಸ್ಫಟಿಕ ಬ್ಲಾಕ್",
  "block.minecraft.quartz_block": "ಸ್ಫಟಿಕ ಶಿಲೆ",
  "block.minecraft.quartz_bricks": "ಸ್ಫಟಿಕ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.quartz_pillar": "ಸ್ಫಟಿಕ ಕಂಬ",
  "block.minecraft.quartz_stairs": "ಸ್ಫಟಿಕ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.activator_rail": "ಆಕ್ಟಿವೇಟರ್ ರೈಲು",
  "block.minecraft.dropper": "ಡ್ರಾಪರ್",
  "block.minecraft.white_terracotta": "ವೈಟ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.orange_terracotta": "ಕಿತ್ತಳೆ ಟೆರಾಕೋಟಾ",
  "block.minecraft.magenta_terracotta": "ಮೆಜೆಂಟಾ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_blue_terracotta": "ಲೈಟ್ ಬ್ಲೂ ಟೆರಾಕೋಟಾ",
  "block.minecraft.yellow_terracotta": "ಹಳದಿ ಟೆರಾಕೋಟಾ",
  "block.minecraft.lime_terracotta": "ನಿಂಬೆ ಟೆರಾಕೋಟಾ",
  "block.minecraft.pink_terracotta": "ಪಿಂಕ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.gray_terracotta": "ಗ್ರೇ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_gray_terracotta": "ಲೈಟ್ ಗ್ರೇ ಟೆರಾಕೋಟಾ",
  "block.minecraft.cyan_terracotta": "ಸೈನ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.purple_terracotta": "ಪರ್ಪಲ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.blue_terracotta": "ಬ್ಲೂ ಟೆರಾಕೋಟಾ",
  "block.minecraft.brown_terracotta": "ಬ್ರೌನ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.green_terracotta": "ಗ್ರೀನ್ ಟೆರ್ರಾಕೋಟಾ",
  "block.minecraft.red_terracotta": "ಕೆಂಪು ಟೆರಾಕೋಟಾ",
  "block.minecraft.black_terracotta": "ಕಪ್ಪು ಟೆರಾಕೋಟಾ",
  "block.minecraft.barrier": "ತಡೆಗೋಡೆ",
  "block.minecraft.iron_trapdoor": "ಐರನ್ ಟ್ರಾಪ್ಡೂರ್",
  "block.minecraft.hay_block": "ಹೇ ಬೇಲ್",
  "block.minecraft.white_carpet": "ಬಿಳಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.orange_carpet": "ಕಿತ್ತಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.magenta_carpet": "ಕಿತ್ತಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.light_blue_carpet": "ತಿಳಿ ನೀಲಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.yellow_carpet": "ಹಳದಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.lime_carpet": "ನಿಂಬೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.pink_carpet": "ಗುಲಾಬಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.gray_carpet": "ಬೂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.light_gray_carpet": "ತಿಳಿ ಬೂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.cyan_carpet": "ವೈಡೂರ್ಯ ಕಾರ್ಪೆಟ್",
  "block.minecraft.purple_carpet": "ನೇರಳೆ ಕಾರ್ಪೆಟ್",
  "block.minecraft.blue_carpet": "ನೀಲಿ ಕಾರ್ಪೆಟ್",
  "block.minecraft.brown_carpet": "ಕಂದು ಕಾರ್ಪೆಟ್",
  "block.minecraft.green_carpet": "ಹಸಿರು ಕಾರ್ಪೆಟ್",
  "block.minecraft.red_carpet": "ಕೆಂಪು ಕಾರ್ಪೆಟ್",
  "block.minecraft.black_carpet": "ಕಪ್ಪು ಕಾರ್ಪೆಟ್",
  "block.minecraft.terracotta": "ಟೆರಾಕೋಟಾ",
  "block.minecraft.coal_block": "ಕಲ್ಲಿದ್ದಲು ಘನಗ",
  "block.minecraft.packed_ice": "ಪ್ಯಾಕ್ಡ್ ಐಸ್",
  "block.minecraft.acacia_stairs": "ಅಕೇಶಿಯ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.dark_oak_stairs": "ಡಾರ್ಕ್ ಓಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.slime_block": "ಲೋಳೆ ಬ್ಲಾಕ್",
  "block.minecraft.grass_path": "ಹುಲ್ಲಿನ ಹಾದಿ",
  "block.minecraft.sunflower": "ಸೂರ್ಯಕಾಂತಿ",
  "block.minecraft.lilac": "ನೀಲಕ",
  "block.minecraft.rose_bush": "ರೋಸ್ ಬುಷ್",
  "block.minecraft.peony": "ಪಿಯೋನಿ",
  "block.minecraft.tall_grass": "ಎತ್ತರದ ಹುಲ್ಲು",
  "block.minecraft.large_fern": "ದೊಡ್ಡ ಜರೀಗಿಡ",
  "block.minecraft.white_stained_glass": "ಬಿಳಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.orange_stained_glass": "ಕಿತ್ತಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.magenta_stained_glass": "ಕೆನ್ನೇರಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.light_blue_stained_glass": "ತಿಳಿ ನೀಲಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.yellow_stained_glass": "ಹಳದಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.lime_stained_glass": "ನಿಂಬೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.pink_stained_glass": "ಗುಲಾಬಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.gray_stained_glass": "ಗ್ರೇ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.light_gray_stained_glass": "ತಿಳಿ ಬೂದು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.cyan_stained_glass": "ಸಯಾನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.purple_stained_glass": "ಕೆನ್ನೇರಳೆ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.blue_stained_glass": "ನೀಲಿ ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.brown_stained_glass": "ಬ್ರೌನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್",
  "block.minecraft.green_stained_glass": "ಹಸಿರು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.red_stained_glass": "ಕೆಂಪು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.black_stained_glass": "ಕಪ್ಪು ಬಣ್ಣದ ಗಾಜು",
  "block.minecraft.white_stained_glass_pane": "ಬಿಳಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.orange_stained_glass_pane": "ಕಿತ್ತಳೆ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.magenta_stained_glass_pane": "ಮೆಜೆಂಟಾ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.light_blue_stained_glass_pane": "ತಿಳಿ ನೀಲಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.yellow_stained_glass_pane": "ಹಳದಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.lime_stained_glass_pane": "ನಿಂಬೆ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.pink_stained_glass_pane": "ಗುಲಾಬಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.gray_stained_glass_pane": "ಗ್ರೇ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.light_gray_stained_glass_pane": "ತಿಳಿ ಬೂದು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.cyan_stained_glass_pane": "ಸಯಾನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.purple_stained_glass_pane": "ಪರ್ಪಲ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.blue_stained_glass_pane": "ನೀಲಿ ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.brown_stained_glass_pane": "ಬ್ರೌನ್ ಸ್ಟೇನ್ಡ್ ಗ್ಲಾಸ್ ಪೇನ್",
  "block.minecraft.green_stained_glass_pane": "ಹಸಿರು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.red_stained_glass_pane": "ಕೆಂಪು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.black_stained_glass_pane": "ಕಪ್ಪು ಬಣ್ಣದ ಗಾಜಿನ ಫಲಕ",
  "block.minecraft.prismarine": "ಪ್ರಿಸ್ಮರಿನ್",
  "block.minecraft.prismarine_bricks": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ಸ್",
  "block.minecraft.dark_prismarine": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್",
  "block.minecraft.prismarine_stairs": "ಪ್ರಿಸ್ಮರಿನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.prismarine_brick_stairs": "ಪ್ರಿಸ್ಮರಿನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.dark_prismarine_stairs": "ಡಾರ್ಕ್ ಪ್ರಿಸ್ಮರಿನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.sea_lantern": "ಸೀ ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.red_sandstone": "ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.chiseled_red_sandstone": "ಕತ್ತರಿಸಿದ ಕೆಂಪು ಮರಳುಗಲ್ಲು",
  "block.minecraft.cut_red_sandstone": "ಕಟ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.red_sandstone_stairs": "ಕೆಂಪು ಮರಳುಗಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.repeating_command_block": "ಕಮಾಂಡ್ ಬ್ಲಾಕ್ ಅನ್ನು ಪುನರಾವರ್ತಿಸಲಾಗುತ್ತಿದೆ",
  "block.minecraft.chain_command_block": "ಚೈನ್ ಕಮಾಂಡ್ ಬ್ಲಾಕ್",
  "block.minecraft.magma_block": "ಶಿಲಾಪಾಕ ಬ್ಲಾಕ್",
  "block.minecraft.nether_wart_block": "ನೆದರ್ ವಾರ್ಟ್ ಬ್ಲಾಕ್",
  "block.minecraft.warped_wart_block": "ರ್ಯಾಪ್ಡ್ ವಾರ್ಟ್ ಬ್ಲಾಕ್",
  "block.minecraft.red_nether_bricks": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.bone_block": "ಮೂಳೆ ಬ್ಲಾಕ್",
  "block.minecraft.structure_void": "ರಚನೆಯ ನಿರರ್ಥಕ",
  "block.minecraft.observer": "ವೀಕ್ಷಕ",
  "block.minecraft.shulker_box": "ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.white_shulker_box": "ಬಿಳಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.orange_shulker_box": "ಕಿತ್ತಳೆ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.magenta_shulker_box": "ಮೆಜೆಂಟಾ ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.light_blue_shulker_box": "ತಿಳಿ ನೀಲಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.yellow_shulker_box": "ಹಳದಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.lime_shulker_box": "ನಿಂಬೆ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.pink_shulker_box": "ಗುಲಾಬಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.gray_shulker_box": "ಗ್ರೇ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.light_gray_shulker_box": "ತಿಳಿ ಬೂದು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.cyan_shulker_box": "ಸಯಾನ್ ಶುಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.purple_shulker_box": "ಪರ್ಪಲ್ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.blue_shulker_box": "ನೀಲಿ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.brown_shulker_box": "ಬ್ರೌನ್ ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.green_shulker_box": "ಹಸಿರು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.red_shulker_box": "ಕೆಂಪು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.black_shulker_box": "ಕಪ್ಪು ಶಲ್ಕರ್ ಬಾಕ್ಸ್",
  "block.minecraft.white_glazed_terracotta": "ಬಿಳಿ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.orange_glazed_terracotta": "ಕಿತ್ತಳೆ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.magenta_glazed_terracotta": "ಮೆಜೆಂಟಾ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_blue_glazed_terracotta": "ಲೈಟ್ ಬ್ಲೂ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.yellow_glazed_terracotta": "ಹಳದಿ ಹೊಳಪುಳ್ಳ ಟೆರಾಕೋಟಾ",
  "block.minecraft.lime_glazed_terracotta": "ನಿಂಬೆ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.pink_glazed_terracotta": "ಪಿಂಕ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.gray_glazed_terracotta": "ಗ್ರೇ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.light_gray_glazed_terracotta": "ಲೈಟ್ ಗ್ರೇ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.cyan_glazed_terracotta": "ಸೈನ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.purple_glazed_terracotta": "ಪರ್ಪಲ್ ಗ್ಲೇಜ್ಡ್ ಟೆರಾಕೋಟಾ",
  "block.minecraft.blue_glazed_terracotta": "ನೀಲಿ ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.brown_glazed_terracotta": "ಬ್ರೌನ್ ಮೆರುಗುಗೊಳಿಸಲಾದ ಟೆರಾಕೋಟಾ",
  "block.minecraft.green_glazed_terracotta": "ಹಸಿರು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.red_glazed_terracotta": "ಕೆಂಪು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.black_glazed_terracotta": "ಕಪ್ಪು ಮೆರುಗಿನ ಟೆರಾಕೋಟಾ",
  "block.minecraft.white_concrete": "ಬಿಳಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.orange_concrete": "ಕಿತ್ತಳೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.magenta_concrete": "ಮೆಜೆಂಟಾ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.light_blue_concrete": "ತಿಳಿ ನೀಲಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.yellow_concrete": "ಹಳದಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.lime_concrete": "ನಿಂಬೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.pink_concrete": "ಗುಲಾಬಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.gray_concrete": "ಬೂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.light_gray_concrete": "ತಿಳಿ ಬೂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.cyan_concrete": "ವೈಡೂರ್ಯದ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.purple_concrete": "ನೇರಳೆ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.blue_concrete": "ನೀಲಿ ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.brown_concrete": "ಕಂದು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.green_concrete": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.red_concrete": "ಕೆಂಪು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.black_concrete": "ಕಪ್ಪು ಕಾಂಕ್ರೀಟ್",
  "block.minecraft.white_concrete_powder": "ಬಿಳಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.orange_concrete_powder": "ಕಿತ್ತಳೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.magenta_concrete_powder": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.light_blue_concrete_powder": "ತಿಳಿ ನೀಲಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.yellow_concrete_powder": "ಹಳದಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.lime_concrete_powder": "ನಿಂಬೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.pink_concrete_powder": "ಗುಲಾಬಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.gray_concrete_powder": "ಬೂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.light_gray_concrete_powder": "ತಿಳಿ ಬೂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.cyan_concrete_powder": "ವೈಡೂರ್ಯದ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.purple_concrete_powder": "ನೇರಳೆ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.blue_concrete_powder": "ನೀಲಿ ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.brown_concrete_powder": "ಕಂದು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.green_concrete_powder": "ಹಸಿರು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.red_concrete_powder": "ಕೆಂಪು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.black_concrete_powder": "ಕಪ್ಪು ಕಾಂಕ್ರೀಟ್ ಪುಡಿ",
  "block.minecraft.turtle_egg": "ಆಮೆ ಎಗ್",
  "block.minecraft.dead_tube_coral_block": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_brain_coral_block": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_bubble_coral_block": "ಡೆಡ್ ಬಬಲ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_fire_coral_block": "ಡೆಡ್ ಫೈರ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.dead_horn_coral_block": "ಡೆಡ್ ಹಾರ್ನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.tube_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.brain_coral_block": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.bubble_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.fire_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.horn_coral_block": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಬ್ಲಾಕ್",
  "block.minecraft.tube_coral": "ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.brain_coral": "ಮೆದುಳಿನ ಹವಳ",
  "block.minecraft.bubble_coral": "ಬಬಲ್ ಹವಳ",
  "block.minecraft.fire_coral": "ಫೈರ್ ಕೋರಲ್",
  "block.minecraft.horn_coral": "ಹಾರ್ನ್ ಕೋರಲ್",
  "block.minecraft.dead_brain_coral": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್",
  "block.minecraft.dead_bubble_coral": "ಡೆಡ್ ಬಬಲ್ ಕೋರಲ್",
  "block.minecraft.dead_fire_coral": "ಡೆಡ್ ಫೈರ್ ಕೋರಲ್",
  "block.minecraft.dead_horn_coral": "ಡೆಡ್ ಹಾರ್ನ್ ಕೋರಲ್",
  "block.minecraft.dead_tube_coral": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.tube_coral_fan": "ಟ್ಯೂಬ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.brain_coral_fan": "ಬ್ರೈನ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.bubble_coral_fan": "ಬಬಲ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.fire_coral_fan": "ಫೈರ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.horn_coral_fan": "ಹಾರ್ನ್ ಕೋರಲ್ ಫ್ಯಾನ್",
  "block.minecraft.dead_tube_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_brain_coral_fan": "ಡೆಡ್ ಬ್ರೈನ್ ಕೋರಲ್",
  "block.minecraft.dead_bubble_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_fire_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.dead_horn_coral_fan": "ಡೆಡ್ ಟ್ಯೂಬ್ ಕೋರಲ್",
  "block.minecraft.blue_ice": "ನೀಲಿ ಐಸ್",
  "block.minecraft.conduit": "ಕಂಡ್ಯೂಟ್",
  "block.minecraft.polished_granite_stairs": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_red_sandstone_stairs": "ಸ್ಮೂತ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mossy_stone_brick_stairs": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_diorite_stairs": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.mossy_cobblestone_stairs": "ಮೊಸ್ಸಿ ಕೊಬ್ಲೆಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.end_stone_brick_stairs": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.stone_stairs": "ಕಲ್ಲಿನ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_sandstone_stairs": "ಸ್ಮೂತ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.smooth_quartz_stairs": "ಸ್ಮೂತ್ ಸ್ಫಟಿಕ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.granite_stairs": "ಗ್ರಾನೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.andesite_stairs": "ಅಂಡಿಸೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.red_nether_brick_stairs": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_andesite_stairs": "ಪಾಲಿಶ್ ಆಂಡೆಸೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.diorite_stairs": "ಡಿಯೊರೈಟ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.polished_granite_slab": "ನಯಗೊಳಿಸಿದ ಗ್ರಾನೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_red_sandstone_slab": "ಸ್ಮೂತ್ ರೆಡ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.mossy_stone_brick_slab": "ಮೊಸ್ಸಿ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.polished_diorite_slab": "ಪಾಲಿಶ್ಡ್ ಡಿಯೊರೈಟ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.mossy_cobblestone_slab": "ಮೊಸ್ಸಿ ಕೊಬ್ಲೆಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.end_stone_brick_slab": "ಎಂಡ್ ಸ್ಟೋನ್ ಬ್ರಿಕ್ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_sandstone_slab": "ಸ್ಮೂತ್ ಸ್ಯಾಂಡ್ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.smooth_quartz_slab": "ಸ್ಮೂತ್ ಸ್ಫಟಿಕ ಚಪ್ಪಡಿ",
  "block.minecraft.granite_slab": "ಗ್ರಾನೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.andesite_slab": "ಅಂಡಿಸೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.red_nether_brick_slab": "ಕೆಂಪು ನೆದರ್ ಇಟ್ಟಿಗೆ ಚಪ್ಪಡಿ",
  "block.minecraft.polished_andesite_slab": "ನಯಗೊಳಿಸಿದ ಅಂಡಿಸೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.diorite_slab": "ಡಿಯೊರೈಟ್ ಚಪ್ಪಡಿ",
  "block.minecraft.scaffolding": "ಸ್ಕ್ಯಾಫೋಲ್ಡಿಂಗ್",
  "block.minecraft.iron_door": "ಕಬ್ಬಿಣದ ಬಾಗಿಲು",
  "block.minecraft.oak_door": "ಓಕ್ ಬಾಗಿಲು",
  "block.minecraft.spruce_door": "ಸ್ಪ್ರೂಸ್ ಡೋರ್",
  "block.minecraft.birch_door": "ಬರ್ಚ್ ಬಾಗಿಲು",
  "block.minecraft.jungle_door": "ಜಂಗಲ್ ಡೋರ್",
  "block.minecraft.acacia_door": "ಅಕೇಶಿಯ ಡೋರ್",
  "block.minecraft.dark_oak_door": "ಡಾರ್ಕ್ ಓಕ್ ಡೋರ್",
  "block.minecraft.crimson_door": "ಕ್ರಿಮ್ಸನ್ ಡೋರ್",
  "block.minecraft.warped_door": "ರ್ಯಾಪ್ಡ್ ಡೋರ್",
  "block.minecraft.repeater": "ರೆಡ್ಸ್ಟೋನ್ ರೆಡಿ",
  "block.minecraft.comparator": "ರೆಡ್‌ಸ್ಟೋನ್ ಹೋಲಿಕೆದಾರ",
  "block.minecraft.structure_block": "ರಚನೆ ಬ್ಲಾಕ್",
  "block.minecraft.jigsaw": "ಜಿಗ್ಸಾ ಬ್ಲಾಕ್",
  "item.minecraft.turtle_helmet": "ಟರ್ಟಲ್ ಶೆಲ್□□ಯಾವಾಗ ತಲೆ:□+2 ಆರ್ಮರ್",
  "item.minecraft.scute": "ಸ್ಕೌಟ್",
  "item.minecraft.iron_shovel": "ಕಬ್ಬಿಣದ ಸಲಿಕೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+3.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.iron_pickaxe": "ಐರನ್ ಪಿಕ್ಸಾ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+3 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.iron_axe": "ಕಬ್ಬಿಣದ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+8 ದಾಳಿ ಹಾನಿ□-3.1 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.flint_and_steel": "ಫ್ಲಿಂಟ್ ಮತ್ತು ಸ್ಟೀಲ್",
  "item.minecraft.apple": "ಸೇಬು",
  "item.minecraft.bow": "ಬಿಲ್ಲು",
  "item.minecraft.arrow": "ಬಾಣ",
  "item.minecraft.coal": "ಕಲ್ಲಿದ್ದಲು",
  "item.minecraft.charcoal": "ಇದ್ದಿಲು",
  "item.minecraft.diamond": "ವಜ್ರ",
  "item.minecraft.iron_ingot": "ಐರನ್ ಇಂಗೊಟ್",
  "item.minecraft.gold_ingot": "ಗೋಲ್ಡ್ ಇಂಗೊಟ್",
  "item.minecraft.netherite_ingot": "ನೆದರೈಟ್ ಇಂಗೋಟ್",
  "item.minecraft.netherite_scrap": "ನೆದರೈಟ್ ಸ್ಕ್ರ್ಯಾಪ್",
  "item.minecraft.iron_sword": "ಐರನ್ ಸ್ವೋರ್ಡ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+5 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.wooden_sword": "ಮರದ ಸ್ವೋರ್ಡ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+3 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.wooden_shovel": "ಮರದ ಸಲಿಕೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+1.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.wooden_pickaxe": "ಮರದ ಪಿಕಕ್ಸೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+1 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.wooden_axe": "ಮರದ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+6 ದಾಳಿ ಹಾನಿ□-3.2 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stone_sword": "ಸ್ಟೋನ್ ಸ್ವೋರ್ಡ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+4 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stone_shovel": "ಕಲ್ಲಿನ ಸಲಿಕೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+2.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stone_pickaxe": "ಸ್ಟೋನ್ ಪಿಕ್ಸಾ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+2 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stone_axe": "ಸ್ಟೋನ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+8 ದಾಳಿ ಹಾನಿ□-3.2 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.diamond_sword": "ಡೈಮಂಡ್ ಸ್ವೋರ್ಡ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+6 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.diamond_shovel": "ವಜ್ರದ ಸಲಿಕೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+4.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.diamond_pickaxe": "ಡೈಮಂಡ್ ಪಿಕಕ್ಸೆ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+4 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.diamond_axe": "ಡೈಮಂಡ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+8 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stick": "ಸ್ಟಿಕ್",
  "item.minecraft.bowl": "ಬೌಲ್",
  "item.minecraft.mushroom_stew": "ಮಶ್ರೂಮ್ ಸ್ಟ್ಯೂ",
  "item.minecraft.golden_sword": "ಗೋಲ್ಡನ್ ಸ್ವೋರ್ಡ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+3 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.golden_shovel": "ಗೋಲ್ಡನ್ ಷೋವೆಲ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+1.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.golden_pickaxe": "ಗೋಲ್ಡನ್ ಪಿಕ್ಸಾ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+1 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.golden_axe": "ಗೋಲ್ಡನ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+6 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.netherite_sword": "ನೆದರೈಟ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+7 ದಾಳಿ ಹಾನಿ□-2.4 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.netherite_shovel": "ನೆದರೈಟ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+5.5 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.netherite_pickaxe": "ನೆದರೈಟ್ ಪಿಕಾಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+5 ದಾಳಿ ಹಾನಿ□-2.8 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.netherite_axe": "ನೆದರೈಟ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+9 ದಾಳಿ ಹಾನಿ□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.string": "ಥ್ರೆಡ್",
  "item.minecraft.feather": "ಗರಿ",
  "item.minecraft.gunpowder": "ಗನ್‌ಪೌಡರ್",
  "item.minecraft.wooden_hoe": "ವುಡನ್ ಹೇ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.stone_hoe": "ಶಿಲಾಯುಗ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□-2 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.iron_hoe": "ಐರನ್ ಹೋ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□-1 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.diamond_hoe": "ಡೈಮಂಡ್ ಹೋ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:",
  "item.minecraft.golden_hoe": "ಗೋಲ್ಡನ್ ಹೇ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□-3 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.netherite_hoe": "ನೆದರೈಟ್ ಏಕ್ಸ್□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:",
  "item.minecraft.wheat_seeds": "ಗೋಧಿ ಬೀಜಗಳು",
  "item.minecraft.wheat": "ಗೋಧಿ",
  "item.minecraft.bread": "ಬ್ರೆಡ್",
  "item.minecraft.leather_helmet": "ಚರ್ಮದ ಕ್ಯಾಪ್□□ಯಾವಾಗ ತಲೆ:□+1 ಆರ್ಮರ್",
  "item.minecraft.leather_chestplate": "ಲೆದರ್ ಟ್ಯೂನಿಕ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+3 ಆರ್ಮರ್",
  "item.minecraft.leather_leggings": "ಲೆದರ್ ಪ್ಯಾಂಟ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+2 ಆರ್ಮರ್",
  "item.minecraft.leather_boots": "ಚರ್ಮದ ಬೂಟುಗಳು□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+1 ಆರ್ಮರ್",
  "item.minecraft.chainmail_helmet": "ಚೈನ್ಮೇಲ್ ಹೆಲ್ಮೆಟ್□□ಯಾವಾಗ ತಲೆ:□+2 ಆರ್ಮರ್",
  "item.minecraft.chainmail_chestplate": "ಚೈನ್ಮೇಲ್ ಚೆಸ್ಟ್ಪ್ಲೇಟ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+5 ಆರ್ಮರ್",
  "item.minecraft.chainmail_leggings": "ಚೈನ್ಮೇಲ್ ಲೆಗ್ಗಿಂಗ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+4 ಆರ್ಮರ್",
  "item.minecraft.chainmail_boots": "ಚೈನ್‌ಮೇಲ್ ಬೂಟ್‌ಗಳು□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+1 ಆರ್ಮರ್",
  "item.minecraft.iron_helmet": "ಕಬ್ಬಿಣದ ಹೆಲ್ಮೆಟ್□□ಯಾವಾಗ ತಲೆ:□+2 ಆರ್ಮರ್",
  "item.minecraft.iron_chestplate": "ಕಬ್ಬಿಣದ ಚೆಸ್ಟ್ಲೇಟ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+6 ಆರ್ಮರ್",
  "item.minecraft.iron_leggings": "ಕಬ್ಬಿಣ ಲೆಗ್ಗಿಂಗ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+5 ಆರ್ಮರ್",
  "item.minecraft.iron_boots": "ಐರನ್ ಬೂಟ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+2 ಆರ್ಮರ್",
  "item.minecraft.diamond_helmet": "ವಜ್ರ ಹೆಲ್ಮೆಟ್□□ಯಾವಾಗ ತಲೆ:□+3 ಆರ್ಮರ್□+2 ಆರ್ಮರ್ ಕಠಿಣತೆ",
  "item.minecraft.diamond_chestplate": "ಡೈಮಂಡ್ ಚೆಸ್ಟ್ಲೇಟ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+8 ಆರ್ಮರ್□+2 ಆರ್ಮರ್ ಕಠಿಣತೆ",
  "item.minecraft.diamond_leggings": "ಡೈಮಂಡ್ ಲೆಗ್ಗಿಂಗ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+6 ಆರ್ಮರ್□+2 ಆರ್ಮರ್ ಕಠಿಣತೆ",
  "item.minecraft.diamond_boots": "ಡೈಮಂಡ್ ಬೂಟ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+3 ಆರ್ಮರ್□+2 ಆರ್ಮರ್ ಕಠಿಣತೆ",
  "item.minecraft.golden_helmet": "ಚಿನ್ನದ ಹೆಲ್ಮೆಟ್□□ಯಾವಾಗ ತಲೆ:□+2 ಆರ್ಮರ್",
  "item.minecraft.golden_chestplate": "ಗೋಲ್ಡನ್ ಚೆಸ್ಟ್ಲೇಟ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+5 ಆರ್ಮರ್",
  "item.minecraft.golden_leggings": "ಗೋಲ್ಡನ್ ಲೆಗ್ಗಿಂಗ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+3 ಆರ್ಮರ್",
  "item.minecraft.golden_boots": "ಗೋಲ್ಡನ್ ಬೂಟ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+1 ಆರ್ಮರ್",
  "item.minecraft.netherite_helmet": "ನೆದರೈಟ್ ಹೆಲ್ಮೆಟ್□□ಯಾವಾಗ ತಲೆ:□+3 ಆರ್ಮರ್□+3 ಆರ್ಮರ್ ಕಠಿಣತೆ□+1 ನಾಕ್ಬ್ಯಾಕ್ ಪ್ರತಿರೋಧ",
  "item.minecraft.netherite_chestplate": "ನೆದರೈಟ್ ಚೆಸ್ಟ್ಪ್ಲೇಟ್□□ದೇಹದಲ್ಲಿರುವಾಗ:□+8 ಆರ್ಮರ್□+3 ಆರ್ಮರ್ ಕಠಿಣತೆ□+1 ನಾಕ್ಬ್ಯಾಕ್ ಪ್ರತಿರೋಧ",
  "item.minecraft.netherite_leggings": "ನೆದರೈಟ್ ಏಕ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇದ್ದಾಗ:□+6 ಆರ್ಮರ್□+3 ಆರ್ಮರ್ ಕಠಿಣತೆ□+1 ನಾಕ್ಬ್ಯಾಕ್ ಪ್ರತಿರೋಧ",
  "item.minecraft.netherite_boots": "ನೆದರೈಟ್ ಬೂಟ್ಸ್□□ಕಾಲುಗಳ ಮೇಲೆ ಇರುವಾಗ:□+3 ಆರ್ಮರ್□+3 ಆರ್ಮರ್ ಕಠಿಣತೆ□+1 ನಾಕ್ಬ್ಯಾಕ್ ಪ್ರತಿರೋಧ",
  "item.minecraft.flint": "ಫ್ಲಿಂಟ್",
  "item.minecraft.porkchop": "ಕಚ್ಚಾ ಪೋರ್ಕ್‌ಚಾಪ್",
  "item.minecraft.cooked_porkchop": "ಬೇಯಿಸಿದ ಹಂದಿಮಾಂಸ",
  "item.minecraft.painting": "ಚಿತ್ರಕಲೆ",
  "item.minecraft.golden_apple": "ಗೋಲ್ಡನ್ ಆಪಲ್",
  "item.minecraft.enchanted_golden_apple": "ಎನ್ಚಾಂಟೆಡ್ ಗೋಲ್ಡನ್ ಆಪಲ್",
  "block.minecraft.oak_sign": "ಓಕ್ ಚಿಹ್ನೆ",
  "block.minecraft.spruce_sign": "ಸ್ಪ್ರೂಸ್ ಸೈನ್",
  "block.minecraft.birch_sign": "ಬಿರ್ಚ್ ಸೈನ್",
  "block.minecraft.jungle_sign": "ಜಂಗಲ್ ಸೈನ್",
  "block.minecraft.acacia_sign": "ಅಕೇಶಿಯ ಸೈನ್",
  "block.minecraft.dark_oak_sign": "ಡಾರ್ಕ್ ಓಕ್ ಸೈನ್",
  "block.minecraft.crimson_sign": "ಕ್ರಿಮ್ಸನ್ ಚಿಹ್ನೆ",
  "block.minecraft.warped_sign": "ರ್ಯಾಪ್ಡ್ ಚಿಹ್ನೆ",
  "item.minecraft.bucket": "ಬಕೆಟ್",
  "item.minecraft.water_bucket": "ನೀರಿನ ಬಕೆಟ್",
  "item.minecraft.lava_bucket": "ಲಾವಾ ಬಕೆಟ್",
  "item.minecraft.minecart": "ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.saddle": "ತಡಿ",
  "item.minecraft.redstone": "ರೆಡ್ಸ್ಟೋನ್ ಧೂಳು",
  "item.minecraft.snowball": "ಸ್ನೋಬಾಲ್",
  "item.minecraft.oak_boat": "ಓಕ್ ದೋಣಿ",
  "item.minecraft.leather": "ಚರ್ಮ",
  "item.minecraft.milk_bucket": "ಹಾಲು ಬಕೆಟ್",
  "item.minecraft.pufferfish_bucket": "ಬಫರ್ ಆಫ್ ಪಫರ್ ಫಿಶ್",
  "item.minecraft.salmon_bucket": "ಸಾಲ್ಮನ್ ಬಕೆಟ್",
  "item.minecraft.cod_bucket": "ಬಕೆಟ್ ಆಫ್ ಕಾಡ್",
  "item.minecraft.tropical_fish_bucket": "ಉಷ್ಣವಲಯದ ಮೀನುಗಳ ಬಕೆಟ್",
  "item.minecraft.brick": "ಇಟ್ಟಿಗೆ",
  "item.minecraft.clay_ball": "ಕ್ಲೇ ಬಾಲ್",
  "block.minecraft.dried_kelp_block": "ಒಣಗಿದ ಕೆಲ್ಪ್ ಬ್ಲಾಕ್",
  "item.minecraft.paper": "ಕಾಗದ",
  "item.minecraft.book": "ಪುಸ್ತಕ",
  "item.minecraft.slime_ball": "ಸ್ಲಿಮ್‌ಬಾಲ್",
  "item.minecraft.chest_minecart": "ಎದೆಯೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.furnace_minecart": "ಕುಲುಮೆಯೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.egg": "ಮೊಟ್ಟೆ",
  "item.minecraft.compass": "ದಿಕ್ಸೂಚಿ",
  "item.minecraft.fishing_rod": "ಫಿಶಿಂಗ್ ರಾಡ್",
  "item.minecraft.clock": "ಗಡಿಯಾರ",
  "item.minecraft.glowstone_dust": "ರೆಡ್ಸ್ಟೋನ್ ಧೂಳು",
  "item.minecraft.cod": "ಕಚ್ಚಾ ಕಾಡ್",
  "item.minecraft.salmon": "ಕಚ್ಚಾ ಸಾಲ್ಮನ್",
  "item.minecraft.tropical_fish": "ಉಷ್ಣವಲಯದ ಮೀನು",
  "item.minecraft.pufferfish": "ಪಫರ್ ಫಿಶ್",
  "item.minecraft.cooked_cod": "ಬೇಯಿಸಿದ ಕಾಡ್",
  "item.minecraft.cooked_salmon": "ಬೇಯಿಸಿದ ಸಾಲ್ಮನ್",
  "item.minecraft.ink_sac": "ಶಾಯಿ ಚೀಲ",
  "item.minecraft.red_dye": "ಕೆಂಪು ಬಣ್ಣ",
  "item.minecraft.green_dye": "ಹಸಿರು ಬಣ್ಣ",
  "item.minecraft.cocoa_beans": "ಕೊಕೊ ಬೀನ್ಸ್",
  "item.minecraft.lapis_lazuli": "ಲ್ಯಾಪಿಸ್ ಲಾಝುಲಿ",
  "item.minecraft.purple_dye": "ಪರ್ಪಲ್ ಡೈ",
  "item.minecraft.cyan_dye": "ವೈಡೂರ್ಯ ಬಣ್ಣ",
  "item.minecraft.light_gray_dye": "ಲೈಟ್ ಗ್ರೇ ಡೈ",
  "item.minecraft.gray_dye": "ಗ್ರೇ ಡೈ",
  "item.minecraft.pink_dye": "ಗುಲಾಬಿ ಬಣ್ಣ",
  "item.minecraft.lime_dye": "ಲೈಮ್ ಡೈ",
  "item.minecraft.yellow_dye": "ಹಳದಿ ಬಣ್ಣ",
  "item.minecraft.light_blue_dye": "ಲೈಟ್ ಬ್ಲೂ ಡೈ",
  "item.minecraft.magenta_dye": "ಮೆಜೆಂತಾ ಡೈ",
  "item.minecraft.orange_dye": "ಕಿತ್ತಳೆ ಬಣ್ಣ",
  "item.minecraft.bone_meal": "ಮೂಳೆ .ಟ",
  "item.minecraft.blue_dye": "ನೀಲಿ ಬಣ್ಣ",
  "item.minecraft.brown_dye": "ಕಂದು ಬಣ್ಣ",
  "item.minecraft.black_dye": "ಕಪ್ಪು ಬಣ್ಣ",
  "item.minecraft.white_dye": "ಬಿಳಿ ಬಣ್ಣ",
  "item.minecraft.bone": "ಮೂಳೆ",
  "item.minecraft.sugar": "ಸಕ್ಕರೆ",
  "block.minecraft.cake": "ಕೇಕ್",
  "block.minecraft.white_bed": "ಬಿಳಿ ಹಾಸಿಗೆ",
  "block.minecraft.orange_bed": "ಕಿತ್ತಳೆ ಹಾಸಿಗೆ",
  "block.minecraft.magenta_bed": "ಮೆಜೆಂತಾ ಡೈ",
  "block.minecraft.light_blue_bed": "ತಿಳಿ ನೀಲಿ ಹಾಸಿಗೆ",
  "block.minecraft.yellow_bed": "ಹಳದಿ ಹಾಸಿಗೆ",
  "block.minecraft.lime_bed": "ನಿಂಬೆ ಹಾಸಿಗೆ",
  "block.minecraft.pink_bed": "ಗುಲಾಬಿ ಹಾಸಿಗೆ",
  "block.minecraft.gray_bed": "ಬೂದು ಹಾಸಿಗೆ",
  "block.minecraft.light_gray_bed": "ತಿಳಿ ಬೂದು ಹಾಸಿಗೆ",
  "block.minecraft.cyan_bed": "ವೈಡೂರ್ಯ ಹಾಸಿಗೆ",
  "block.minecraft.purple_bed": "ನೇರಳೆ ಹಾಸಿಗೆ",
  "block.minecraft.blue_bed": "ನೀಲಿ ಹಾಸಿಗೆ",
  "block.minecraft.brown_bed": "ಕಂದು ಹಾಸಿಗೆ",
  "block.minecraft.green_bed": "ಹಸಿರು ಹಾಸಿಗೆ",
  "block.minecraft.red_bed": "ಕೆಂಪು ಹಾಸಿಗೆ",
  "block.minecraft.black_bed": "ಕಪ್ಪು ಹಾಸಿಗೆ",
  "item.minecraft.cookie": "ಕುಕಿ",
  "item.minecraft.filled_map": "ನಕ್ಷೆ□#0",
  "item.minecraft.shears": "ಕತ್ತರಿ",
  "item.minecraft.melon_slice": "ಕಲ್ಲಂಗಡಿ ತುಂಡು",
  "item.minecraft.dried_kelp": "ಒಣಗಿದ ಕೆಲ್ಪ್",
  "item.minecraft.pumpkin_seeds": "ಕುಂಬಳಕಾಯಿ ಬೀಜಗಳು",
  "item.minecraft.melon_seeds": "ಕಲ್ಲಂಗಡಿ ಬೀಜಗಳು",
  "item.minecraft.beef": "ಕಚ್ಚಾ ಗೋಮಾಂಸ",
  "item.minecraft.cooked_beef": "ಸ್ಟೀಕ್",
  "item.minecraft.chicken": "ಕಚ್ಚಾ ಚಿಕನ್",
  "item.minecraft.cooked_chicken": "ಬೇಯಿಸಿದ ಚಿಕನ್",
  "item.minecraft.rotten_flesh": "ಕೊಳೆತ ಮಾಂಸ",
  "item.minecraft.ender_pearl": "ಎಂಡರ್ ಪರ್ಲ್",
  "item.minecraft.blaze_rod": "ಬ್ಲೇಜ್ ರಾಡ್",
  "item.minecraft.ghast_tear": "ಘಾಸ್ಟ್ ಟಿಯರ್",
  "item.minecraft.gold_nugget": "ಗೋಲ್ಡ್ ನುಗ್ಗೆಟ್",
  "item.minecraft.nether_wart": "ನೆದರ್ ನರಹುಲಿ",
  "item.minecraft.potion": "ರಚಿಸಲಾಗದ ಮದ್ದು□ಯಾವುದೇ ಪರಿಣಾಮಗಳಿಲ್ಲ",
  "item.minecraft.glass_bottle": "ಗಾಜಿನ ಬಾಟಲ್",
  "item.minecraft.spider_eye": "ಜೇಡ ಕಣ್ಣು",
  "item.minecraft.fermented_spider_eye": "ಹುದುಗಿಸಿದ ಸ್ಪೈಡರ್ ಐ",
  "item.minecraft.blaze_powder": "ಬ್ಲೇಜ್ ಪೌಡರ್",
  "item.minecraft.magma_cream": "ಶಿಲಾಪಾಕ ಕ್ರೀಮ್",
  "block.minecraft.brewing_stand": "ಬ್ರೂಯಿಂಗ್ ಸ್ಟ್ಯಾಂಡ್",
  "block.minecraft.cauldron": "ಕೌಲ್ಡ್ರನ್",
  "item.minecraft.ender_eye": "ಎಂಡರ್ ಕಣ್ಣು",
  "item.minecraft.glistering_melon_slice": "ಮೆಲೋನ್ ಸ್ಲೈಸ್ ಗ್ಲಿಸ್ಟರ್",
  "item.minecraft.bat_spawn_egg": "ಬ್ಯಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.bee_spawn_egg": "ಬೀ ಸ್ಪಾವ್ನ್ ಎಗ್",
  "item.minecraft.blaze_spawn_egg": "ಬ್ಲೇಜ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.cat_spawn_egg": "ಕ್ಯಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.cave_spider_spawn_egg": "ಗುಹೆ ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.chicken_spawn_egg": "ಚಿಕನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.cod_spawn_egg": "ಕಾಡ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.cow_spawn_egg": "ಹಸು ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.creeper_spawn_egg": "ಕ್ರೀಪರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.dolphin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.donkey_spawn_egg": "ಕತ್ತೆ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.drowned_spawn_egg": "ಸ್ಪಾನ್ ಎಗ್ ಮುಳುಗಿತು",
  "item.minecraft.elder_guardian_spawn_egg": "ಎಲ್ಡರ್ ಗಾರ್ಡಿಯನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.enderman_spawn_egg": "ಎಂಡರ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.endermite_spawn_egg": "ಎಂಡರ್ಮೈಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.evoker_spawn_egg": "ಇವೊಕರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.fox_spawn_egg": "ಫಾಕ್ಸ್ ಎಗ್ ಸ್ಪಾನ್",
  "item.minecraft.ghast_spawn_egg": "ಘಾಸ್ಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.guardian_spawn_egg": "ಗಾರ್ಡಿಯನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.hoglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.horse_spawn_egg": "ಕುದುರೆ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.husk_spawn_egg": "ಹೊಟ್ಟು ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.llama_spawn_egg": "ಲಾಮಾ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.magma_cube_spawn_egg": "ಮ್ಯಾಗ್ಮಾ ಕ್ಯೂಬ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.mooshroom_spawn_egg": "ಮೂಶ್ರೂಮ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.mule_spawn_egg": "ಮ್ಯೂಲ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.ocelot_spawn_egg": "ಒಸೆಲಾಟ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.panda_spawn_egg": "ಪಾಂಡ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.parrot_spawn_egg": "ಗಿಳಿ ಮೊಟ್ಟೆಯ ಮೊಟ್ಟೆ",
  "item.minecraft.phantom_spawn_egg": "ಫ್ಯಾಂಟಮ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.pig_spawn_egg": "ಪಿಗ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.piglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.pillager_spawn_egg": "ಪಿಲ್ಲರ್ ಎಗ್ ಸ್ಪಾನ್",
  "item.minecraft.polar_bear_spawn_egg": "ಹಿಮಕರಡಿ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.pufferfish_spawn_egg": "ಪಫರ್ ಫಿಶ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.rabbit_spawn_egg": "ಮೊಲ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.ravager_spawn_egg": "ರಾವೆಗರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.salmon_spawn_egg": "ಸಾಲ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.sheep_spawn_egg": "ಕುರಿ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.shulker_spawn_egg": "ಶಲ್ಕರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.silverfish_spawn_egg": "ಸಿಲ್ವರ್‌ಫಿಶ್ ಸ್ಪಾವ್ನ್ ಎಗ್",
  "item.minecraft.skeleton_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.skeleton_horse_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಕುದುರೆ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.slime_spawn_egg": "ಲೋಳೆ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.spider_spawn_egg": "ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.squid_spawn_egg": "ಸ್ಕ್ವಿಡ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.stray_spawn_egg": "ದಾರಿತಪ್ಪಿ ಸ್ಪಾನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.strider_spawn_egg": "ಸ್ಪೈಡರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.trader_llama_spawn_egg": "ವ್ಯಾಪಾರಿ ಲಾಮಾ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.tropical_fish_spawn_egg": "ಉಷ್ಣವಲಯದ ಮೀನು ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.turtle_spawn_egg": "ಟರ್ಟಲ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.vex_spawn_egg": "ವೆಕ್ಸ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.villager_spawn_egg": "ಗ್ರಾಮಸ್ಥ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.vindicator_spawn_egg": "ವಿಂಡಿಕೇಟರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.wandering_trader_spawn_egg": "ವ್ಯಾಂಡರ್ ವ್ಯಾಪಾರಿ ಟ್ರೇಡರ್ ಮೊಟ್ಟೆ ಮೊಟ್ಟೆ",
  "item.minecraft.witch_spawn_egg": "ಮಾಟಗಾತಿ ಮೊಟ್ಟೆ ಮೊಟ್ಟೆ",
  "item.minecraft.wither_skeleton_spawn_egg": "ಅಸ್ಥಿಪಂಜರ ಸ್ಪಾವ್ನ್ ಮೊಟ್ಟೆ",
  "item.minecraft.wolf_spawn_egg": "ತೋಳ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zoglin_spawn_egg": "ಡಾಲ್ಫಿನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_spawn_egg": "ಝಾಂಬಿ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_horse_spawn_egg": "ಝಾಂಬಿ ಹಾರ್ಸ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombie_villager_spawn_egg": "ಝಾಂಬಿ ವಿಲೇಜರ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.zombified_piglin_spawn_egg": "ಝಾಂಬಿ ಪಿಗ್ಮನ್ ಸ್ಪಾನ್ ಎಗ್",
  "item.minecraft.experience_bottle": "ಬಾಟಲ್ ಒ 'ಮೋಡಿಮಾಡುವ",
  "item.minecraft.fire_charge": "ಫೈರ್ ಚಾರ್ಜ್",
  "item.minecraft.writable_book": "ಪುಸ್ತಕ ಮತ್ತು ಕ್ವಿಲ್",
  "item.minecraft.written_book": "ಲಿಖಿತ ಪುಸ್ತಕ",
  "item.minecraft.emerald": "ಪಚ್ಚೆ",
  "item.minecraft.item_frame": "ಫ್ರೇಮ್",
  "block.minecraft.flower_pot": "ಹೂ ಕುಂಡ",
  "item.minecraft.carrot": "ಕ್ಯಾರೆಟ್",
  "item.minecraft.potato": "ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.baked_potato": "ಬೇಯಿಸಿದ ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.poisonous_potato": "ವಿಷಕಾರಿ ಆಲೂಗೆಡ್ಡೆ",
  "item.minecraft.map": "ಖಾಲಿ ನಕ್ಷೆ",
  "item.minecraft.golden_carrot": "ಗೋಲ್ಡನ್ ಕ್ಯಾರೆಟ್",
  "block.minecraft.skeleton_skull": "ಅಸ್ಥಿಪಂಜರ ತಲೆಬುರುಡೆ",
  "block.minecraft.wither_skeleton_skull": "ಅಸ್ಥಿಪಂಜರ ತಲೆಬುರುಡೆ",
  "block.minecraft.player_head": "ಆಟಗಾರನ ತಲೆ",
  "block.minecraft.zombie_head": "ಝಾಂಬಿ ಹೆಡ್",
  "block.minecraft.creeper_head": "ಕ್ರೀಪರ್ ತಲೆ",
  "block.minecraft.dragon_head": "ಡ್ರ್ಯಾಗನ್ ತಲೆ",
  "item.minecraft.carrot_on_a_stick": "ಕಡ್ಡಿ ಕಡ್ಡಿ",
  "item.minecraft.warped_fungus_on_a_stick": "ಒಂದು ಕೋಲಿನ ಮೇಲೆ ರ್ಯಾಪ್ಡ್ ಶಿಲೀಂಧ್ರ",
  "item.minecraft.nether_star": "ನೆದರ್ ನಕ್ಷತ್ರ",
  "item.minecraft.pumpkin_pie": "ಕುಂಬಳಕಾಯಿ ಕೇಕ್",
  "item.minecraft.firework_rocket": "ಪಟಾಕಿ ರಾಕೆಟ್",
  "item.minecraft.firework_star": "ಪಟಾಕಿ ಸ್ಟಾರ್",
  "item.minecraft.enchanted_book": "ಎನ್ಚ್ಯಾಂಟೆಡ್ ಪುಸ್ತಕ",
  "item.minecraft.nether_brick": "ನೆದರ್ ಬ್ರಿಕ್",
  "item.minecraft.quartz": "ನೆದರ್ ಸ್ಫಟಿಕ ಶಿಲೆ",
  "item.minecraft.tnt_minecart": "ಟಿಎನ್‌ಟಿಯೊಂದಿಗೆ ಮೈನ್‌ಕಾರ್ಟ್",
  "item.minecraft.hopper_minecart": "ಹಾಪರ್ ಜೊತೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.prismarine_shard": "ಪ್ರಿಸ್ಮರಿನ್ ಶಾರ್ಡ್",
  "item.minecraft.prismarine_crystals": "ಪ್ರಿಸ್ಮರಿನ್ ಕ್ರಿಸ್ಟಲ್ಸ್",
  "item.minecraft.rabbit": "ಕಚ್ಚಾ ಮೊಲ",
  "item.minecraft.cooked_rabbit": "ಬೇಯಿಸಿದ ಮೊಲ",
  "item.minecraft.rabbit_stew": "ಮೊಲ ಸ್ಟ್ಯೂ",
  "item.minecraft.rabbit_foot": "ಮೊಲದ ಕಾಲು",
  "item.minecraft.rabbit_hide": "ಮೊಲ ಮರೆಮಾಡು",
  "item.minecraft.armor_stand": "ಪ್ರತಿಮೆ",
  "item.minecraft.iron_horse_armor": "ಐರನ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.golden_horse_armor": "ಗೋಲ್ಡನ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.diamond_horse_armor": "ಡೈಮಂಡ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.leather_horse_armor": "ಲೆದರ್ ಹಾರ್ಸ್ ಆರ್ಮರ್",
  "item.minecraft.lead": "ಲೀಡ್",
  "item.minecraft.name_tag": "ಹೆಸರು ಟ್ಯಾಗ್",
  "item.minecraft.command_block_minecart": "ಕಮಾಂಡ್ ಬ್ಲಾಕ್ನೊಂದಿಗೆ ಮಿನೆಕಾರ್ಟ್",
  "item.minecraft.mutton": "ಕಚ್ಚಾ ಮಟನ್",
  "item.minecraft.cooked_mutton": "ಬೇಯಿಸಿದ ಮಟನ್",
  "block.minecraft.white_banner": "ಬಿಳಿ ಬ್ಯಾನರ್",
  "block.minecraft.orange_banner": "ಕಿತ್ತಳೆ ಬ್ಯಾನರ್",
  "block.minecraft.magenta_banner": "ಮೆಜೆಂಟಾ ಬ್ಯಾನರ್",
  "block.minecraft.light_blue_banner": "ತಿಳಿ ನೀಲಿ ಬ್ಯಾನರ್",
  "block.minecraft.yellow_banner": "ಹಳದಿ ಬ್ಯಾನರ್",
  "block.minecraft.lime_banner": "ನಿಂಬೆ ಬ್ಯಾನರ್",
  "block.minecraft.pink_banner": "ಪಿಂಕ್ ಬ್ಯಾನರ್",
  "block.minecraft.gray_banner": "ಬೂದು ಬ್ಯಾನರ್",
  "block.minecraft.light_gray_banner": "ತಿಳಿ ಬೂದು ಬ್ಯಾನರ್",
  "block.minecraft.cyan_banner": "ವೈಡೂರ್ಯದ ಬ್ಯಾನರ್",
  "block.minecraft.purple_banner": "ನೇರಳೆ ಬ್ಯಾನರ್",
  "block.minecraft.blue_banner": "ನೀಲಿ ಬ್ಯಾನರ್",
  "block.minecraft.brown_banner": "ಕಂದು ಬ್ಯಾನರ್",
  "block.minecraft.green_banner": "ಹಸಿರು ಬ್ಯಾನರ್",
  "block.minecraft.red_banner": "ಕೆಂಪು ಬ್ಯಾನರ್",
  "block.minecraft.black_banner": "ಕಪ್ಪು ಬ್ಯಾನರ್",
  "item.minecraft.end_crystal": "ಎಂಡ್ ಕ್ರಿಸ್ಟಲ್",
  "item.minecraft.chorus_fruit": "ಕೋರಸ್ ಹಣ್ಣು",
  "item.minecraft.popped_chorus_fruit": "ಬೇಯಿಸಿದ ಕೋರಸ್ ಹಣ್ಣು",
  "item.minecraft.beetroot": "ಬೀಟ್ರೂಟ್",
  "item.minecraft.beetroot_seeds": "ಬೀಟ್ರೂಟ್ ಬೀಜಗಳು",
  "item.minecraft.beetroot_soup": "ಬೀಟ್ರೂಟ್ ಸೂಪ್",
  "item.minecraft.dragon_breath": "ಡ್ರ್ಯಾಗನ್ ಉಸಿರು",
  "item.minecraft.splash_potion": "ಸ್ಪ್ಲಾಶ್ ಅನ್ಕ್ರಾಫ್ಟಬಲ್ ಮದ್ದು□ಯಾವುದೇ ಪರಿಣಾಮಗಳಿಲ್ಲ",
  "item.minecraft.spectral_arrow": "ಸ್ಪೆಕ್ಟ್ರಲ್ ಬಾಣ",
  "item.minecraft.tipped_arrow": "ಕ್ರಾಫ್ಟಬಲ್ ಟಿಪ್ಡ್ ಬಾಣ□ಯಾವುದೇ ಪರಿಣಾಮಗಳಿಲ್ಲ",
  "item.minecraft.lingering_potion": "ಕಾಲಹರಣ ಮಾಡಲಾಗದ ಮದ್ದು□ಯಾವುದೇ ಪರಿಣಾಮಗಳಿಲ್ಲ",
  "item.minecraft.shield": "ಗುರಾಣಿ",
  "item.minecraft.elytra": "ಎಲಿತ್ರಾ",
  "item.minecraft.spruce_boat": "ಸ್ಪ್ರೂಸ್ ಬೋಟ್",
  "item.minecraft.birch_boat": "ಬರ್ಚ್ ದೋಣಿ",
  "item.minecraft.jungle_boat": "ಜಂಗಲ್ ಬೋಟ್",
  "item.minecraft.acacia_boat": "ಅಕೇಶಿಯ ಬೋಟ್",
  "item.minecraft.dark_oak_boat": "ಡಾರ್ಕ್ ಓಕ್ ಬೋಟ್",
  "item.minecraft.totem_of_undying": "ಅಂತ್ಯವಿಲ್ಲದ ಟೋಟೆಂ",
  "item.minecraft.shulker_shell": "ಶುಲ್ಕರ್ ಶೆಲ್",
  "item.minecraft.iron_nugget": "ಐರನ್ ನುಗ್ಗೆಟ್",
  "item.minecraft.knowledge_book": "ಜ್ಞಾನ ಪುಸ್ತಕ",
  "item.minecraft.debug_stick": "ಡೀಬಗ್ ಸ್ಟಿಕ್",
  "item.minecraft.music_disc_13": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - 13",
  "item.minecraft.music_disc_cat": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - cat",
  "item.minecraft.music_disc_blocks": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - blocks",
  "item.minecraft.music_disc_chirp": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - chirp",
  "item.minecraft.music_disc_far": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - far",
  "item.minecraft.music_disc_mall": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - mall",
  "item.minecraft.music_disc_mellohi": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - mellohi",
  "item.minecraft.music_disc_stal": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - stal",
  "item.minecraft.music_disc_strad": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - strad",
  "item.minecraft.music_disc_ward": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - ward",
  "item.minecraft.music_disc_11": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - 11",
  "item.minecraft.music_disc_wait": "ಸಂಗೀತ ಡಿಸ್ಕ್□c418 - wait",
  "item.minecraft.music_disc_pigstep": "ಸಂಗೀತ ಡಿಸ್ಕ್□ಲೆನಾ ರೈನ್ - ಪಿಗ್‌ಸ್ಟೆಪ್",
  "item.minecraft.trident": "ತ್ರಿಶೂಲ□□ಮುಖ್ಯ ಕೈಯಲ್ಲಿರುವಾಗ:□+8 ದಾಳಿ ಹಾನಿ□-2.9 ಆಕ್ರಮಣದ ವೇಗ",
  "item.minecraft.phantom_membrane": "ಫ್ಯಾಂಟಮ್ ಮೆಂಬರೇನ್",
  "item.minecraft.nautilus_shell": "ನಾಟಿಲಸ್ ಶೆಲ್",
  "item.minecraft.heart_of_the_sea": "ಹಾರ್ಟ್ ಆಫ್ ದಿ ಸೀ",
  "item.minecraft.crossbow": "ಅಡ್ಡಬಿಲ್ಲು",
  "item.minecraft.suspicious_stew": "ಅನುಮಾನಾಸ್ಪದ ಸ್ಟ್ಯೂ",
  "block.minecraft.loom": "ಲೂಮ್",
  "item.minecraft.flower_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ□ಹೂ ಚಾರ್ಜ್",
  "item.minecraft.creeper_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ□ಕ್ರೀಪರ್ ಚಾರ್ಜ್",
  "item.minecraft.skull_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ□ಸ್ಕಲ್ ಚಾರ್ಜ್",
  "item.minecraft.mojang_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ□ವಿಷಯ",
  "item.minecraft.globe_banner_pattern": "ಬ್ಯಾನರ್ ಪ್ಯಾಟರ್ನ್□ಗ್ಲೋಬ್",
  "item.minecraft.piglin_banner_pattern": "ಬ್ಯಾನರ್ ನಮೂನೆ□ಗೊರಕೆ",
  "block.minecraft.composter": "ಸಂಯೋಜಕ",
  "block.minecraft.barrel": "ಬ್ಯಾರೆಲ್",
  "block.minecraft.smoker": "ಧೂಮಪಾನಿ",
  "block.minecraft.blast_furnace": "ಬ್ಲಾಸ್ಟ್ ಫರ್ನೇಸ್",
  "block.minecraft.cartography_table": "ಕಾರ್ಟೋಗ್ರಫಿ ಟೇಬಲ್",
  "block.minecraft.fletching_table": "ಫ್ಲೆಚಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.grindstone": "ಗ್ರಿಂಡ್ಸ್ಟೋನ್",
  "block.minecraft.lectern": "ಲೆಕ್ಟರ್ನ್",
  "block.minecraft.smithing_table": "ಸ್ಮಿಮಿಂಗ್ ಟೇಬಲ್",
  "block.minecraft.stonecutter": "ಸ್ಟಾನ್ಕಾಕಿಟರ್",
  "block.minecraft.bell": "ಗಂಟೆ",
  "block.minecraft.lantern": "ಲ್ಯಾಂಟರ್ನ್",
  "block.minecraft.soul_lantern": "ಸೋಲ್ ಲ್ಯಾಂಟರ್ನ್",
  "item.minecraft.sweet_berries": "ಸಿಹಿ ಹಣ್ಣುಗಳು",
  "block.minecraft.campfire": "ಕ್ಯಾಂಪ್ಫೈರ್",
  "block.minecraft.soul_campfire": "ಸೋಲ್ ಕ್ಯಾಂಪ್‌ಫೈರ್",
  "block.minecraft.shroomlight": "ಶ್ರೂಮ್ಲೈಟ್",
  "item.minecraft.honeycomb": "ಜೇನುಗೂಡು",
  "block.minecraft.bee_nest": "ಜೇನುನೊಣ ಗೂಡು",
  "block.minecraft.beehive": "ಬೀಹೈವ್",
  "item.minecraft.honey_bottle": "ಹನಿ ಬಾಟಲ್",
  "block.minecraft.honey_block": "ಹನಿ ಬ್ಲಾಕ್",
  "block.minecraft.honeycomb_block": "ಜೇನುಗೂಡು ಬ್ಲಾಕ್",
  "block.minecraft.lodestone": "ಲೋಡೆಸ್ಟೋನ್",
  "block.minecraft.netherite_block": "ನೆದರೈಟ್ನ ಬ್ಲಾಕ್",
  "block.minecraft.ancient_debris": "ಪ್ರಾಚೀನ ಶಿಲಾಖಂಡರಾಶಿಗಳು",
  "block.minecraft.target": "ಗುರಿ",
  "block.minecraft.crying_obsidian": "ಅಳುವುದು ಅಬ್ಸಿಡಿಯನ್",
  "block.minecraft.blackstone": "ಕಪ್ಪು ಕಲ್ಲಿನ",
  "block.minecraft.blackstone_slab": "ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಸ್ಲ್ಯಾಬ್",
  "block.minecraft.blackstone_stairs": "ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.gilded_blackstone": "ಗಿಲ್ಡೆಡ್ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.polished_blackstone": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.polished_blackstone_slab": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಚಪ್ಪಡಿ",
  "block.minecraft.polished_blackstone_stairs": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.chiseled_polished_blackstone": "ಕತ್ತರಿಸಿದ ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್",
  "block.minecraft.polished_blackstone_bricks": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.polished_blackstone_brick_slab": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.polished_blackstone_brick_stairs": "ನಯಗೊಳಿಸಿದ ಬ್ಲಾಕ್‌ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆ ಮೆಟ್ಟಿಲುಗಳು",
  "block.minecraft.cracked_polished_blackstone_bricks": "ಕ್ರ್ಯಾಕ್ಡ್ ಪಾಲಿಶ್ಡ್ ಬ್ಲಾಕ್ಸ್ಟೋನ್ ಇಟ್ಟಿಗೆಗಳು",
  "block.minecraft.respawn_anchor": "ರೆಸ್ಪಾನ್ ಆಂಕರ್",
}
export const kn_in = items; 
